import { Pipe, PipeTransform } from '@angular/core';
import { PendingDocument } from 'src/app/shared/models/pending-document.model';

import { elementAt } from 'rxjs/operators';

@Pipe({
  name: 'agrupacionNif',
  pure: false
})
export class AgrupacionNifPipe implements PipeTransform {

  constructor() {
  }

  transform(lista: PendingDocument[], tipoDocumento: number = 0): any[] {
    
    if (!lista) {
      return [];
    }
    
    let resultado = [];

    lista = lista.filter( l => l.tipoDocumento == tipoDocumento);

    lista.forEach(element => {
      let position = resultado.map(function(e) { return e.nif; }).indexOf(element.nifDocumento);
      if (position == -1) {
        resultado.push({
          nif: element.nifDocumento,
          secundario: element.secundario,
          plantilla: element.nifConPlantilla,
          numeroDocumentos: lista.filter( l => l.tipoDocumento == tipoDocumento && l.nifDocumento == element.nifDocumento ).length,
          puedePlantilla: false,
          documentosGrabadosPorNif: element.documentosGrabadosPorNif
        });
      }      
    });
    
    return resultado;
  }

}
